import { Controller } from 'stimulus'
import { pathname }   from '@react/helpers/fetch'

const DEBOUNCE = 300

// Warns the user, while typing, when another equipment of the same site
// already uses the serial number. Never blocks the form: it only displays a
// green (available) or red (already used) message under the field.
export default class extends Controller {

  static targets = ['input', 'site', 'feedback']

  connect() {
    this._debounce = null
    this._request  = 0
  }

  disconnect() {
    clearTimeout(this._debounce)
  }

  check() {
    clearTimeout(this._debounce)
    this._debounce = setTimeout(() => this._fetch(), DEBOUNCE)
  }

  _fetch() {
    const serialNumber = this.hasInputTarget ? this.inputTarget.value.trim() : ''
    const siteId       = this._siteId()

    if (!serialNumber || !siteId) {
      this._clear()
      return
    }

    const params = {
      serial_number: serialNumber,
      site_id:       siteId
    }
    if (this.data.get('materialId')) params.material_id = this.data.get('materialId')

    const url     = pathname({ path: this.data.get('route'), params, format: 'json' })
    const request = ++this._request

    fetch(url, {
      credentials: 'same-origin',
      headers:     { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => response.json())
      .then(payload => {
        // Discard the answers of the keystrokes the user already went past.
        if (request === this._request) this._render(payload)
      })
      .catch(() => this._clear())
  }

  _render(payload) {
    if (!this.hasFeedbackTarget) return
    if (!payload || payload.status === 'blank') {
      this._clear()
      return
    }

    const taken = payload.status === 'taken'
    const names = (payload.duplicates || []).map(duplicate => duplicate.name).filter(Boolean)

    this.feedbackTarget.className   = `small mt-1 ${taken ? 'text-danger' : 'text-success'}`
    this.feedbackTarget.textContent = taken && names.length
      ? `${payload.message} (${names.join(', ')})`
      : payload.message
  }

  _siteId() {
    if (this.data.get('siteId')) return this.data.get('siteId')

    return this.hasSiteTarget ? this.siteTarget.value : ''
  }

  _clear() {
    if (!this.hasFeedbackTarget) return

    this.feedbackTarget.className   = ''
    this.feedbackTarget.textContent = ''
  }
}
